import { computed } from 'vue'
import { useStorage } from '@vueuse/core'
import { isEmpty } from 'lodash-es'

export const TOKEN_KEY = 'AUTH_TOKEN'

// 创建全局共享的 token 实例
const token = useStorage<string>(TOKEN_KEY, '')

// 计算属性：判断是否已登录
const isLoggedIn = computed(() => {
  return !!token.value && token.value.trim().length > 0
})

// 设置 token
const setToken = (newToken: string) => {
  if (!isEmpty(newToken) && newToken.trim()) {
    token.value = newToken.trim()
  } else {
    token.value = ''
    console.log('Empty token provided, clearing token')
  }
}

// 清除 token（退出登录）
const clearToken = () => {
  console.log('🗑️ Clearing token')
  token.value = ''
}

// 获取 token
const getToken = () => {
  return token.value
}

// 直接导出 clearToken，供非 Vue 上下文使用
export { clearToken }

export function useToken() {
  return {
    token,
    isLoggedIn,
    setToken,
    clearToken,
    getToken
  }
}
